import { Controller } from "@hotwired/stimulus"
import moment from 'moment'

export default class extends Controller {
  connect() {
    document.querySelector('#recipient_type_member').addEventListener('change', this.selectRecipientType.bind(this))
    document.querySelector('#recipient_type_facility').addEventListener('change', this.selectRecipientType.bind(this))
  }
  
  sendFormRequest() {
    const facility = $('#affiliate_facility_id').val();
    const member = $('#member_id').val();
    const organization = $('#organization_id').val();
    var url = `/organizations/${organization}/facilities/${facility}/create_form_request.turbo_stream`
    if (document.querySelector('#member_select_wrapper').style.display === 'block'){
      url = `/organizations/${organization}/affiliate_members/${member}/create_form_request.turbo_stream`
    }
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: JSON.stringify({ token: $('#form_id').val() })
    }).then(response => {
      if (response.ok) {
        return response.text();
      }
    }).then(turboStreamHTML => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = turboStreamHTML;
    
      const turboStreamElement = tempDiv.querySelector('turbo-stream');
      if (turboStreamElement) {
        document.getElementById('flash_messages_div').innerHTML = turboStreamElement.querySelector('template').innerHTML;
      }
      $('#send_request_modal').modal('hide')
    })
      
  }
  
  selectRecipientType(event) {
    const type = event.target.value
    document.querySelector('#member_select_wrapper').style.display = type === "member" ? "block" : "none"
    document.querySelector('#facility_select_wrapper').style.display = type === "facility" ? "block" : "none"
  }
  
  setForm() {
    $('#form_id').val(event.target.dataset.form);
  }
}
